// TODO: frames

import { postImageWrapperClass } from "@repo/fika-blog/src/postHeader.css"
import type { AccentHue } from "@repo/fika-design-system/color"
import { createEffect, createSignal } from "solid-js"
import { resize } from "@/pages/posts/image-upload"
import { FileUpload } from "./file-upload"
import { backgroundClass } from "./file-upload.css"

type Props = {
  onUpload: (src: string | null) => void
  text: string
  imageSrc?: string | null
  hue: AccentHue
}

export function ImageUpload(props: Props) {
  const [imageSrc, setImageSrc] = createSignal(props.imageSrc)

  createEffect(() => {
    const url = props.imageSrc

    if (!url) return setImageSrc(null)
    if (imageSrc() === url) return

    const img = new Image()
    img.onload = () => setImageSrc(url)
    img.onerror = () => setImageSrc(null)
    img.src = url
  })

  async function handleFileUpload(file: File | null) {
    if (!file) {
      props.onUpload(null)
      return
    }

    const src = await resize(file)
    props.onUpload(src)
  }

  return (
    <FileUpload
      onUpload={handleFileUpload}
      text={props.text}
      hue={props.hue}
      accept="image/*"
      iconName="image-up"
      hasFile={!!imageSrc()}
    >
      <div class={postImageWrapperClass}>
        <img src={imageSrc()!} class={backgroundClass} alt="" />
      </div>
    </FileUpload>
  )
}
